import Vue from "vue";
import Router from "vue-router";

// module page
import dashboard from "./modules/dashboard";
import buyMedicine from "./modules/buy-medicine";
import profile from "./modules/profile";
import consultation from "./modules/consultation";
import biling from "./modules/biling";
import rekamMedis from "./modules/rekam-medis";
import familyMembers from "./modules/family-members";
import promo from "./modules/promo";
import inspectionReport from "./modules/inspectionReport";
import detailPromo from "./modules/detailpromo";
import visitSchedule from "./modules/visit-schedule";
import pasien from "./modules/pasien";
import upgradeMember from "./modules/upgradeMember";
import visitForm from "./modules/formVisit";
import formBiling from "./modules/formPaymentBiling";
import shopingCharMedicine from "./modules/shoping-chart";
import chekout from "./modules/checkout";
import detailOrder from "./modules/detailOrder";
import ex from "./modules/examination";
import diagnosis from "./modules/diagnosis";
import formAction from "./modules/formAction";
import pesanan from "./modules/order";

Vue.use(Router);

export const constantRoutes = [
  {
    path: "/redirect",
    hidden: true,
    children: [
      {
        path: "/redirect/:path*",
        component: () => import("@/components/redirect/index")
      }
    ]
  },
  {
    path: "/404",
    component: () => import("@/components/error-page/404"),
    hidden: true
  },
  {
    path: "/401",
    component: () => import("@/components/error-page/401"),
    hidden: true
  },
  {
    path: "/forgot",
    component: () => import("@/components/login/forgot"),
    hidden: false,
    name: "Forgot",
    meta: {
      title: "Forgot Password",
      icon: "fa-user"
    }
  },
  {
    path: "/login",
    component: () => import("@/components/login/login"),
    hidden: false,
    name: "Login",
    meta: {
      title: "Login",
      icon: "fa-key"
    }
  },
  {
    path: "/registrasi",
    component: () => import("@/components/login/registrasi"),
    hidden: false,
    name: "registrasi",
    meta: {
      title: "Registrasi",
      icon: "fa-user"
    }
  },

  {
    path: "/",
    name: "Dashboard",
    hidden: false,
    redirect: "/dashboard",
    meta: {
      title: "Dashboard",
      icon: "fa-dashboard"
    }
  }
];

export const asyncRoutes = [
  dashboard,
  profile,
  visitSchedule,
  consultation,
  pasien,
  rekamMedis,
  buyMedicine,
  promo,
  inspectionReport,
  detailPromo,
  biling,
  familyMembers,
  upgradeMember,
  visitForm,
  formBiling,
  shopingCharMedicine,
  chekout,
  detailOrder,
  ex,
  diagnosis,
  formAction,
  pesanan,
  {
    path: "*",
    redirect: "/404",
    hidden: true
  }
];
const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({
      y: 0
    }),
    routes: constantRoutes
  });

const router = createRouter();
// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js